class LFSeguimiento extends HTMLElement {
 constructor() {
  super();
  this.form = this.querySelector('form');
  this.input = this.querySelector('input');
  this.button = this.querySelector('button');
  this.loading = this.querySelector('.loading');
  this.results = this.querySelector('.lf__results');
  this.error = this.querySelector('.lf__error');
  this.table_cells = this.querySelectorAll('[data-cell]')
 }
 connectedCallback() {
  this.button.addEventListener('click', (event) => this.validateAndGetOrder());
  this.form.addEventListener('submit', (event) => {
   event.preventDefault()
   this.validateAndGetOrder()
  });
 }

 async validateAndGetOrder() {
  const input = this.input
  if(input.value.trim() === '') return;
  this.loading.classList.remove('hidden');
  this.results.classList.add('hidden');
  this.error.classList.add('hidden');
  await this.getOrder(input.value.trim());
 }

 async getOrder(code) {
  const isoDateRegex = /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}\.\d{3}Z$/;
  const value = code;

  const myHeaders = new Headers();
  myHeaders.append("X-Api-Key", "JazsctRZRZkP5IIy3TmHr7w2cZaQPV1iDxY87FciF5YJdoLh");
  myHeaders.append("Content-Type", "application/x-www-form-urlencoded");

  const urlencoded = new URLSearchParams();
  urlencoded.append("code", `LF${value}`);

  const requestOptions = {
   method: "POST",
   headers: myHeaders,
   body: urlencoded,
   redirect: "follow"
  };
  try {
   const response = await fetch("https://api.weflapp.com/integrations/generic/full-order-status", requestOptions);
   const data = await response.json();
   const orderData = data[0]

   const {
    // status,
    Order: {
     customerName, code, customerPhone, customerEmail, shippingAddress: { address1, address2, commune }
    },
    Shipments: [
     {
      status,
      statusHistory: {
       created,
       collecting,
       ontheway,
       delivered
      }
     }
    ],
    trackingUrl
   } = orderData;

   const map = {
    status,
    customerName, code, customerPhone, customerEmail,
    address1, address2, commune,
    created, collecting, ontheway, delivered,
    trackingUrl
   }; 

   this.table_cells.forEach(cell => {
    const dataCellValue = cell.getAttribute('data-cell');
    if (dataCellValue === 'trackingUrl') {
    //  cell.innerHTML = `<a href="${map.trackingUrl}" target="_blank"> Más información </a>`;
     cell.innerHTML = `<iframe src="${map.trackingUrl}" height="580px" width="360px" frameborder="0"></iframe>`;
    }
    else if (dataCellValue === 'shippingAddress') {
     cell.textContent = `${map.address1}${map.address2 ? ` - ${map.address2}` : ''}, ${map.commune}.`;
    } else {
     const value = map[dataCellValue];
     const isDate = isoDateRegex.test(value);

     if (isDate) {
      cell.textContent = this.formatDateCL(value);
     } else {
      cell.textContent = 
      map[dataCellValue] === 'delivered' ? 'Entregado' :
      map[dataCellValue] === 'collecting' ? 'Listo para envío' :
      map[dataCellValue] === 'ontheway' ? 'En camino' :
      map[dataCellValue] === 'pickup-ready' ? 'Listo para retiro' :
      map[dataCellValue] === 'created' ? 'Listo para envío' :
      map[dataCellValue] === 'pending' ? 'Procesando' :
       map[dataCellValue];
     }
    }
   })

   this.results.classList.remove('hidden');
  } catch (error) {
   console.error(error, '?ERROR');
   this.error.classList.remove('hidden');
  } finally {
   this.loading.classList.add('hidden');
  }
 }

 formatDateCL(isoString) {
  const date = new Date(isoString);
  if (isNaN(date.getTime())) return isoString;
  return new Intl.DateTimeFormat('es-CL', {
   day: '2-digit',
   month: '2-digit',
   year: 'numeric',
   hour: '2-digit',
   minute: '2-digit',
   hour12: false
  }).format(date);
 }

}

customElements.define('lf-seguimiento', LFSeguimiento);

document.querySelectorAll('motion-element').forEach((e) => e.style.opacity = 1)